export default function Spinners() {
  return (
    <div className="pt-1 text-center">
      <div className="spinner-border text-danger" />
    </div>
  );
}
